import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AuditQueryResult, deserialiseAuditQueryResults, ENVIRONMENT, HateoasMultipleResponseObject, markAsBackgroundServiceCall, ReportRunService, ReportSpecificationService } from '@scisys-uim/uim-common';
import { Firearm, FirearmRevision } from 'assets-model';
import { Observable } from 'rxjs';
import { ReturnFirearmToStorageData } from '../../firearm_assignment/model/firearm-assignment.service';
import { FirearmServiceBase } from './firearm.service.base';


export interface StoreFirearmData extends ReturnFirearmToStorageData {
  assetId: number;
}

export interface SuspendFirearmData extends StoreFirearmData {
}

export interface ReturnFirearmData extends StoreFirearmData {
}

export interface AcquireFirearmData extends StoreFirearmData {
}

export interface DisposeFirearmData extends StoreFirearmData {
}

export interface UnsuspendFirearmData {
  assetId: number;
}

export interface TransferFirearmData extends StoreFirearmData {
  buId?: string;
  ccId?: string;
}


@Injectable({
  providedIn: 'root'
})
export class FirearmService extends FirearmServiceBase {
  constructor(protected reportRunService: ReportRunService,
    protected reportSpecificationService: ReportSpecificationService,
    http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment, reportRunService, reportSpecificationService);
  }


  acquireFirearm(item: AcquireFirearmData): Observable<Firearm> {
    return this.deserialise(
      this.http.post<Firearm>(this.serviceBaseUrl + '/acquireFirearm', item));
  }

  disposeFirearm(item: DisposeFirearmData): Observable<Firearm> {
    return this.deserialise(
      this.http.post<Firearm>(this.serviceBaseUrl + '/disposeFirearm', item));
  }

  returnFirearm(item: ReturnFirearmData): Observable<Firearm> {
    return this.deserialise(
      this.http.post<Firearm>(this.serviceBaseUrl + '/returnFirearm', item));
  }

  suspendFirearm(item: SuspendFirearmData): Observable<Firearm> {
    return this.deserialise(
      this.http.post<Firearm>(this.serviceBaseUrl + '/suspendFirearm', item));
  }

  unsuspendFirearm(item: UnsuspendFirearmData): Observable<Firearm> {
    return this.deserialise(
      this.http.post<Firearm>(this.serviceBaseUrl + '/unsuspendFirearm', item));
  }

  transferFirearm(item: TransferFirearmData): Observable<Firearm> {
    return this.deserialise(
      this.http.post<Firearm>(this.serviceBaseUrl + '/transferFirearm', item));
  }

  public findAuditHistory(assetId: number): Observable<any[]> {
    return this.deserialiseFirearmAuditQueryResult(this.http.get<AuditQueryResult<Firearm>[]>(this.serviceBaseUrl + '/findAuditHistory/' + assetId));
  }

  protected deserialiseFirearmAuditQueryResult(response: Observable<AuditQueryResult<Firearm>[]>): Observable<any[]> {
    return deserialiseAuditQueryResults(response, r => new FirearmRevision(r));
  }

  public getFirearmsFromFile(file: File): Observable<HateoasMultipleResponseObject<Firearm>> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    var params = new HttpParams();
    return this.deserialiseMultipleResponse(this.http.post<HateoasMultipleResponseObject<Firearm>>(this.serviceBaseUrl + "/getFirearmsFromFile", formData, { params: params }));
  }

  public importAll(rows: Firearm[]): Observable<HateoasMultipleResponseObject<Firearm>> {
    var params = new HttpParams();
    return this.deserialiseMultipleResponse(this.http.post<HateoasMultipleResponseObject<Firearm>>(this.serviceBaseUrl + "/importAll", this.serialiseMultiple(rows), {
      params: params
    }));
  }

    public exampleMaintenanceNotificationTemplateParameters(backgroundServiceCall: boolean = true): Observable<{
      [key: string]: string
    }> {
      return this.http.get<{ [key: string]: string }>(this.serviceBaseUrl + '/exampleMaintenanceNotificationTemplateParameters', {
        headers: backgroundServiceCall ? markAsBackgroundServiceCall() : null
      });
    }

}



